if (typeof document === "undefined") return;
var createStylesheet = (chunkId, fullhref, oldTag, resolve, reject) => {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	if (__webpack_require__.nc) {
		linkTag.nonce = __webpack_require__.nc;
	}
	var onLinkComplete = (event) => {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && event.type;
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + errorType + ": " + realHref + ")");
			err.name = "ChunkLoadError";
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			if (linkTag.parentNode) linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;


	(function stylesInjector(styleEl, targetEl, anchorEl) {
	  if (!styleEl) {
	    return;
	  }

	  function isMobile() {
	    const targetWidth = window.innerWidth;
	    const userAgent = navigator.userAgent;
	    const MOBILE_BREAKPOINT = 980; // Consider making this configurable

	    // Check for mobile user agents
	    const isMobileUserAgent = /(iPad|iPhone|iPod|android|webOS)/i.test(userAgent);

	    // iPad Pro devices with large screens should not be considered mobile
	    if (targetWidth > MOBILE_BREAKPOINT && /iPad|android/i.test(userAgent)) {
	      return false;
	    }

	    // Small screens are always considered mobile
	    if (targetWidth <= MOBILE_BREAKPOINT) {
	      return true;
	    }

	    return isMobileUserAgent;
	  }

	  // TODO: TMP stub for reload on resize in mobile mode
	  // Remove this after container queries are fully removed
	  const isWasInitInMobile = isMobile();
	  const mq = window.matchMedia('(max-width: 980px)');
	  mq.addEventListener('change', (e) => {
	    if (isWasInitInMobile) {
	      window.location.reload();
	    }
	  });

	  const cssLayerId = 'css-layers-definition';
	  const appCssLayerDefinition = `
	      @layer
	          base,
	          deprecated,
	          components-tmp,
	          pro-layout,
	          components,
	          utilities-deprecated,
	          utilities,
	          partner-theme,
	          shadow-mode,
	          rtl;
	    `;

	  // Unified helper: transforms "@media (…width…)" into "@container shadow-container (…)",
	  // and converts relative url(...) paths to absolute ones, all in a single pass.
	  const transformCss = (cssText, cssUrl) =>
	    cssText.replace(
	      /@media\s*([^{]*\([^)]*\))|url\((['"]?)([^'")]+)\2\)/g,
	      (match, mediaCond, quote, url) => {
	        // Branch 1: media query detected
	        if (mediaCond) {
	          if (!mediaCond.includes('width')) {
	            return match; // not a width-based query
	          }
	          // Keep only the part starting with the first "("
	          const idx = mediaCond.indexOf('(');
	          const pureCond = idx >= 0 ? mediaCond.slice(idx) : mediaCond;
	          return `@container shadow-container ${pureCond}`;
	        }

	        // Branch 2: url(...) detected
	        if (!cssUrl) {
	          return match;
	        }

	        if (/^(data:|https?:|blob:|\/\/)/i.test(url)) {
	          return match;
	        }

	        const q = quote || '';
	        try {
	          const absolute = new URL(url, cssUrl).href;
	          return `url(${q}${absolute}${q})`;
	        } catch {
	          return match;
	        }
	      },
	    );

	  // Helper to clean up the blob URL after the load event to avoid memory leaks.
	  const addBlobCleanup = (el, blobUrl) => {
	    const revokeUrl = () => {
	      URL.revokeObjectURL(blobUrl);
	      el.removeEventListener('load', revokeUrl);
	    };
	    el.addEventListener('load', revokeUrl);
	  };

	  const supportsContainerQueries =
	    CSS &&
	    (CSS.supports('container-type', 'inline-size') || CSS.supports('container-type', 'size'));

	  const app = window.document.querySelector('#sportsbook-app');
	  const isShadowMode = !!app?.shadowRoot;
	  const currentDocument = isShadowMode ? app.shadowRoot : window.document;
	  const tagName = styleEl.tagName.toLowerCase();

	  // Inject CSS layer definition as the first style element if missing (both modes)
	  if (!currentDocument.querySelector(`#${cssLayerId}`)) {
	    const layerDefinition = document.createElement('style');
	    layerDefinition.id = cssLayerId;
	    layerDefinition.textContent = appCssLayerDefinition;

	    // Insert at the very beginning to ensure layer order
	    if (isShadowMode) {
	      currentDocument.prepend(layerDefinition);
	    } else {
	      // In normal mode, insert in document head before any other styles
	      document.head.prepend(layerDefinition);
	    }
	  }

	  // Reference element used to insert styles before
	  let reference = anchorEl || currentDocument.querySelector('#chunk-styles');

	  // If anchor doesn't exist, create it
	  if (!reference) {
	    const chunkStylesAnchor = document.createElement('div');
	    chunkStylesAnchor.id = 'chunk-styles';
	    currentDocument.append(chunkStylesAnchor);
	    reference = chunkStylesAnchor;
	  }

	  // Inserts the given element into the DOM.
	  // If a target element is provided, it appends to it directly.
	  // Otherwise, inserts before the #chunk-styles reference anchor.
	  const insertToDOM = (el) => {
	    if (targetEl) {
	      targetEl.appendChild(el);
	    } else {
	      reference.before(el);
	    }
	  };

	  // Inject <link> styles before the reference element
	  if (tagName === 'link') {
	    insertToDOM(styleEl);
	  }

	  // Warn if container queries are not supported in shadow mode
	  if (isShadowMode && !supportsContainerQueries) {
	    console.warn('This browser does not support ContainerQueries');
	    return;
	  }

	  if (tagName === 'style') {
	    if (isShadowMode && !isWasInitInMobile) {
	      // Modify inline <style> content if in shadow mode and container queries are supported
	      styleEl.textContent = transformCss(styleEl.textContent, styleEl.baseURI);
	    }
	    // Insert the <style> element (either modified or not) into the DOM
	    insertToDOM(styleEl);
	  } else if (tagName === 'link' && isShadowMode && !isWasInitInMobile) {
	    // Add a flag to prevent infinite loops in firefox
	    if (styleEl.dataset.processed) {
	      return;
	    }

	    const handleLoad = () => {
	      // Mark as processed to prevent re-execution in firefox
	      styleEl.dataset.processed = 'true';

	      try {
	        const sheet = styleEl.sheet;

	        // Check if the stylesheet is accessible and contains rules
	        if (sheet && sheet.cssRules?.length > 0) {
	          // Iterate backwards since rules might be deleted during the loop
	          for (let i = sheet.cssRules.length - 1; i >= 0; i--) {
	            const rule = sheet.cssRules[i];

	            // Look for media queries that include "width" in the condition
	            if (
	              (rule instanceof CSSMediaRule || rule instanceof CSSLayerBlockRule) &&
	              rule.conditionText.includes('width')
	            ) {
	              const newRuleText = transformCss(rule.cssText);

	              // Replace the existing rule with the modified one
	              sheet.deleteRule(i);
	              sheet.insertRule(newRuleText, i);
	            }
	          }
	        }
	      } catch (error) {
	        // Remove the event listener BEFORE making changes that might trigger it again
	        styleEl.removeEventListener('load', handleLoad);

	        // Fallback: fetch the CSS file manually if direct modification fails
	        fetch(styleEl.href, { cache: 'force-cache' })
	          .then((response) => response.text())
	          .then((rawCss) => {
	            // Skip if the CSS doesn't contain any media queries
	            if (!rawCss.includes('@media')) {
	              return;
	            }

	            // Transform media queries and absolutize url(...) in one go
	            const modifiedCssText = transformCss(rawCss, styleEl.href);
	            const blob = new Blob([modifiedCssText], { type: 'text/css' }); // handle with axios and https://axios-http.com/docs/multipart
	            const blobUrl = URL.createObjectURL(blob);

	            // Replace the original stylesheet with the modified version
	            styleEl.href = blobUrl;
	            addBlobCleanup(styleEl, blobUrl);
	          })
	          .catch((error) => console.error('Error fetching CSS:', error));
	      }
	    };

	    styleEl.addEventListener('load', handleLoad);
	  }
	})(linkTag)
	return linkTag;
};
var findStylesheet = (href, fullhref) => {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = (chunkId) => {
	return new Promise((resolve, reject) => {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, null, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	218: 0,
	524: 0
};

__webpack_require__.f.miniCss = (chunkId, promises) => {
	var cssChunks = {"405":1,"497":1,"711":1,"752":1,"820":1,"860":1,"940":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(() => {
			installedCssChunks[chunkId] = 0;
		}, (e) => {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr

// no prefetching

// no preloaded